// import React, { useEffect, useState } from "react";
// import SearchIcon from "@mui/icons-material/Search";
// import { Link } from "react-router-dom";
// import toast from "react-hot-toast";
// import Pagination from "@mui/material/Pagination";
// import Stack from "@mui/material/Stack";
// import InvoicePurchaseModal from "../../Components/InvoicePurchaseModal";
// import purchaseService from "../../Services/purchaseService";
// import moment from "moment";
// import { Eye } from "lucide-react";
// import { useNavigate } from "react-router-dom";

// const Purchases = () => {
//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const itemsPerPage = 10;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedPurchase, setSelectedPurchase] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const getPurchases = async () => {
//       try {
//         setLoading(true);
//         const response = await purchaseService.fetchAll();
//         console.log(response);
//         setRecords(response.purchases);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching Purhases");
//       }
//     };
//     getPurchases();
//   }, []);

//   useEffect(() => {
//     const filteredResult =
//       records?.filter((item) =>
//         item?.name?.toLowerCase().includes(searchData.toLowerCase())
//       ) || [];
//     setFilteredData(filteredResult);
//     setCurrentPage(1);
//   }, [searchData, records]);

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
//   }, [currentPage, filteredData]);

//   const handlePageChange = (event, page) => {
//     setCurrentPage(page);
//   };

//   const handleOpenModal = (purchase) => {
//     setSelectedPurchase(purchase);
//     setModalOpen(true);
//   };

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[19px] text-gray-700 font-[700]">Purchases</h1>
//         <h1 className="ml-[3%] text-[13px] text-gray-700 mb-4">
//           {filteredData?.length || 0} records found
//         </h1>

//         <div className="flex mt-8 flex-row-reverse justify-between px-[3%]">
//           <Link to="RecordPurchases">
//             <button className="bg-white text-primary shadow-[2px_2px_6px_rgba(0,0,0,0.2)] px-8 py-3 rounded-lg font-[600] text-[14px]">
//               + Purchase Medicines
//             </button>
//           </Link>

//           <div className="w-[40%]">
//             <input
//               type="search"
//               placeholder="Search Purchases Here..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="block w-[90%] pl-10 text-gray-900 p-2 border-b-2 border-gray-200 focus:border-primary focus:outline-none"
//             />
//             <SearchIcon className="mt-[-4rem] text-gray-400 ml-2" />
//           </div>
//         </div>

//         <div className="mx-[3%]">
//           <table className="w-full border-collapse rounded-lg overflow-hidden shadow-xl shadow-gray-300">
//             <thead>
//               <tr className="bg-primary text-white capitalize leading-normal text-left text-xs">
//                 <th className="p-4 w-[15%]">
//                   Purchases Id
//                 </th>
//                 <th className="p-4 w-[20%]">
//                   Supplier Name
//                 </th>
//                 <th className="p-4 w-[15%]">
//                   Company Name
//                 </th>
//                 <th className="p-4 w-[15%]">
//                   Amount
//                 </th>
//                 <th className="p-4 w-[15%]">
//                   Purchase Date
//                 </th>
//                 <th className="p-4 w-[15%] text-center">
//                   Action
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData?.map((patient, index) => (
//                 <tr
//                   key={patient?.patient_id}
//                   className="text-xs border-t border-gray-200"
//                 >
//                   <td className="p-3 pl-4 w-[15%] font-bold text-primary">
//                   {patient?.id}
//                   </td>
//                   <td className="p-3 w-[20%] font-bold">
//                     {patient?.name}
//                   </td>
//                   <td className="p-3 w-[15%]">
//                     {patient?.company}
//                   </td>
//                   <td className="p-3 w-[15%]">
//                     {patient?.amount}
//                   </td>
//                   <td className="p-3 w-[15%]">
//                     {moment(patient?.date).format("ll")}
//                   </td>
//                   <td className="p-3 w-[15%] text-center">
//                   <button
//                     onClick={() => navigate(`purchaseView/${patient.id}`, {
//                       state: { company: patient.company, name: patient.name },
//                     })}
//                   >
//                   <Eye className="w-5 h-5 text-gray-500 hover:text-primary cursor-pointer" />
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//         <div className="flex justify-center my-4">
//           <Stack spacing={2}>
//             <Pagination
//               count={Math.ceil(filteredData.length / itemsPerPage)}
//               page={currentPage}
//               onChange={handlePageChange}
//               variant="outlined"
//               shape="rounded"
//             />
//           </Stack>
//         </div>
//       </div>
//       <InvoicePurchaseModal
//         open={modalOpen}
//         onClose={() => setModalOpen(false)}
//         purchase={selectedPurchase}
//       />
            
//     </div>
//   );
// };

// export default Purchases;

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import InvoicePurchaseModal from "../../Components/InvoicePurchaseModal";
import purchaseService from "../../Services/purchaseService";
import moment from "moment";
import {
  MdSearch,
  MdShoppingCart,
  MdAdd,
  MdVisibility,
  MdChevronLeft,
  MdChevronRight,
} from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const ITEMS_PER_PAGE = 10;

const Purchases = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewLoading, setViewLoading] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPurchase, setSelectedPurchase] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const getPurchases = async () => {
      try {
        setLoading(true);
        const response = await purchaseService.fetchAll();
        setRecords(response.purchases);
      } catch (error) {
        toast.error("Error fetching Purchases");
      } finally {
        setLoading(false);
      }
    };
    getPurchases();
  }, []);

  useEffect(() => {
    const result =
      records?.filter((item) =>
        item?.name?.toLowerCase().includes(searchData.toLowerCase())
      ) || [];
    setFilteredData(result);
    setCurrentPage(1);
  }, [searchData, records]);

  useEffect(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    setPaginatedData(filteredData?.slice(start, start + ITEMS_PER_PAGE) || []);
  }, [currentPage, filteredData]);

  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

  const totalSpent = records.reduce(
    (sum, p) => sum + parseFloat(p.amount || 0),
    0
  );

  const todayPurchases = records.filter(
    (p) =>
      moment(p.date).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")
  ).length;

  const handleView = (patient) => {
    setViewLoading(patient.id);
    navigate(`purchaseView/${patient.id}`, {
      state: { company: patient.company, name: patient.name },
    });
  };

  const pageNumbers = () => {
    const pages = [];
    const delta = 2;
    for (
      let i = Math.max(1, currentPage - delta);
      i <= Math.min(totalPages, currentPage + delta);
      i++
    ) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap');
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .fade-up { animation: fadeUp 0.5s ease both; }
      `}</style>

      <div
        className="min-h-screen bg-[#f4f7fb] py-5 px-3 sm:py-8 sm:px-4 fade-up"
        style={{ fontFamily: "'DM Sans', sans-serif" }}
      >
        <div className="max-w-[1400px] mx-auto">

          {/* ── Page Header ── */}
          <div className="mb-5 sm:mb-8 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
            <div>
              <div className="flex items-center gap-2.5 sm:gap-3 mb-1">
                <div
                  className="w-8 h-8 sm:w-9 sm:h-9 rounded-xl flex items-center justify-center shrink-0"
                  style={{ background: "linear-gradient(135deg, #00A95B, #007a40)" }}
                >
                  <MdShoppingCart size={17} className="text-white" />
                </div>
                <h1
                  className="text-[#0a2540] text-[20px] sm:text-[26px] leading-tight"
                  style={{ fontFamily: "'DM Serif Display', serif" }}
                >
                  Purchases
                </h1>
              </div>
              <p className="text-[#8a9bb0] text-[12px] sm:text-sm ml-[42px] sm:ml-12">
                {filteredData.length} record{filteredData.length !== 1 ? "s" : ""} found
              </p>
            </div>

            <Link to="RecordPurchases" className="w-full sm:w-auto">
              <button
                className="flex items-center justify-center gap-2 px-4 sm:px-5 py-2.5 rounded-xl text-white text-[13px] sm:text-[14px] font-semibold tracking-[0.3px] transition-all hover:-translate-y-px whitespace-nowrap w-full sm:w-auto"
                style={{
                  background: "linear-gradient(135deg, #00A95B 40%, #007a40 100%)",
                  boxShadow: "0 4px 16px rgba(0,169,91,0.35)",
                }}
              >
                <MdAdd size={18} />
                Purchase Medicines
              </button>
            </Link>
          </div>

          {/* ── Summary Cards ── */}
          {/* <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
            <SummaryCard
              label="Total Purchases"
              value={records.length}
              color="#0a2540"
              bg="#f4f7fb"
              border="border-[#eef1f6]"
            />
            <SummaryCard
              label="Today's Purchases"
              value={todayPurchases}
              color="#e96f1f"
              bg="#fff7f0"
              border="border-orange-100"
            />
            <SummaryCard
              label="Total Spent"
              value={`Rs. ${totalSpent.toLocaleString("en-PK", { minimumFractionDigits: 2 })}`}
              color="#00A95B"
              bg="#f0fdf7"
              border="border-emerald-100"
            />
          </div> */}

          {/* ── Search + Table Card ── */}
          <div className="bg-white rounded-2xl shadow-sm border border-[#eef1f6] overflow-hidden">

            {/* Search Bar */}
            <div className="px-4 py-3.5 sm:px-6 sm:py-4 border-b border-[#eef1f6]">
              <div className="relative w-full sm:w-[360px]">
                <MdSearch
                  size={18}
                  className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#8a9bb0] pointer-events-none"
                />
                <input
                  type="search"
                  placeholder="Search by supplier name..."
                  value={searchData}
                  onChange={(e) => setSearchData(e.target.value)}
                  className="w-full pl-10 pr-4 py-[10px] bg-[#f8fafc] border-[1.5px] border-[#dde4ed] rounded-xl text-[14px] text-[#0a2540] outline-none transition-all placeholder:text-[#b0bcc9] focus:border-[#00A95B] focus:shadow-[0_0_0_4px_rgba(0,169,91,0.1)] focus:bg-white"
                />
              </div>
            </div>

            {/* ── Table view: md and up ── */}
            <div className="hidden md:block overflow-x-auto">
              <table className="w-full text-left">
                <thead>
                    <tr style={{ background: '#00A95B' }}>
                    {["Purchase ID", "Supplier Name", "Company", "Amount", "Purchase Date", "Action"].map((h) => (
                      <th
                        key={h}
                        className={`px-5 py-3.5 text-[11px] font-semibold uppercase tracking-[0.6px] text-white whitespace-nowrap ${
                          h === "Action" ? "text-center" : ""
                        }`}
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="6" className="text-center py-16">
                        <div className="flex flex-col items-center gap-3 text-[#8a9bb0]">
                          <AiOutlineLoading3Quarters
                            size={28}
                            className="animate-spin text-[#00A95B]"
                          />
                          <span className="text-sm">Loading purchases…</span>
                        </div>
                      </td>
                    </tr>
                  ) : paginatedData.length > 0 ? (
                    paginatedData.map((item, index) => (
                      <tr
                        key={item?.id}
                        className={`text-[13px] border-b border-[#f0f4f8] transition-colors ${
                          index % 2 === 0 ? "bg-white" : "bg-[#fafbfd]"
                        } hover:bg-[#f0fdf7]`}
                      >
                        <td className="px-5 py-3.5 font-bold text-[#00A95B]">
                          {item?.id}
                        </td>
                        <td className="px-5 py-3.5 font-semibold text-[#0a2540]">
                          {item?.name}
                        </td>
                        <td className="px-5 py-3.5 text-[#4a6080]">
                          {item?.company}
                        </td>
                        <td className="px-5 py-3.5 font-semibold text-[#0a2540]">
                          Rs.{" "}
                          {parseFloat(item?.amount).toLocaleString("en-PK", {
                            minimumFractionDigits: 2,
                          })}
                        </td>
                        <td className="px-5 py-3.5 text-[#4a6080]">
                          <span className="inline-flex items-center text-[12px] bg-[#f4f7fb] border border-[#eef1f6] px-2.5 py-1 rounded-lg">
                            {moment(item?.date).format("ll")}
                          </span>
                        </td>
                        <td className="px-5 py-3.5 text-center">
                          <button
                            onClick={() => handleView(item)}
                            disabled={viewLoading === item.id}
                            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[12px] font-semibold border border-[#dde4ed] text-[#4a6080] hover:border-[#00A95B] hover:text-[#00A95B] hover:bg-[#f0fdf7] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            {viewLoading === item.id ? (
                              <AiOutlineLoading3Quarters size={13} className="animate-spin" />
                            ) : (
                              <MdVisibility size={14} />
                            )}
                            View
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center py-14">
                        <div className="flex flex-col items-center gap-2 text-[#b0bcc9]">
                          <MdShoppingCart size={32} className="text-[#dde4ed]" />
                          <span className="text-sm">
                            {searchData
                              ? "No purchases match your search."
                              : "No purchase records found."}
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* ── Card view: below md ── */}
            <div className="md:hidden">
              {loading ? (
                <div className="flex flex-col items-center gap-3 text-[#8a9bb0] py-14">
                  <AiOutlineLoading3Quarters
                    size={26}
                    className="animate-spin text-[#00A95B]"
                  />
                  <span className="text-sm">Loading purchases…</span>
                </div>
              ) : paginatedData.length > 0 ? (
                <ul className="divide-y divide-[#f0f4f8]">
                  {paginatedData.map((item) => (
                    <li key={item?.id} className="p-4 flex flex-col gap-3">
                      {/* Purchase ID + Supplier Name + Action */}
                      <div className="flex items-start justify-between gap-3">
                        <div className="min-w-0">
                          <span className="block text-[10px] font-semibold uppercase tracking-[0.5px] text-[#8a9bb0] mb-0.5">
                            #{item?.id} · Supplier Name
                          </span>
                          <span className="font-semibold text-[#0a2540] text-[14.5px] break-words leading-snug">
                            {item?.name}
                          </span>
                        </div>
                        <button
                          onClick={() => handleView(item)}
                          disabled={viewLoading === item.id}
                          className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-[11.5px] font-semibold border border-[#dde4ed] text-[#4a6080] active:bg-[#f0fdf7] active:border-[#00A95B] active:text-[#00A95B] transition-all disabled:opacity-50 shrink-0"
                        >
                          {viewLoading === item.id ? (
                            <AiOutlineLoading3Quarters size={12} className="animate-spin" />
                          ) : (
                            <MdVisibility size={13} />
                          )}
                          View
                        </button>
                      </div>

                      {/* Company */}
                      <div>
                        <span className="block text-[10px] font-semibold uppercase tracking-[0.5px] text-[#8a9bb0] mb-0.5">
                          Company
                        </span>
                        <span className="text-[#4a6080] text-[13px] break-words">
                          {item?.company}
                        </span>
                      </div>

                      {/* Amount + Purchase Date */}
                      <div className="flex items-end justify-between gap-3">
                        <div>
                          <span className="block text-[10px] font-semibold uppercase tracking-[0.5px] text-[#8a9bb0] mb-0.5">
                            Amount
                          </span>
                          <span className="font-bold text-[#0a2540] text-[13.5px]">
                            Rs.{" "}
                            {parseFloat(item?.amount).toLocaleString("en-PK", {
                              minimumFractionDigits: 2,
                            })}
                          </span>
                        </div>
                        <div className="text-right">
                          <span className="block text-[10px] font-semibold uppercase tracking-[0.5px] text-[#8a9bb0] mb-0.5">
                            Purchase Date
                          </span>
                          <span className="inline-flex items-center text-[#4a6080] bg-[#f4f7fb] border border-[#eef1f6] px-2.5 py-1 rounded-lg text-[11.5px]">
                            {moment(item?.date).format("ll")}
                          </span>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="flex flex-col items-center gap-2 text-[#b0bcc9] py-12 px-4 text-center">
                  <MdShoppingCart size={28} className="text-[#dde4ed]" />
                  <span className="text-sm">
                    {searchData
                      ? "No purchases match your search."
                      : "No purchase records found."}
                  </span>
                </div>
              )}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="px-4 py-3.5 sm:px-6 sm:py-4 border-t border-[#eef1f6] flex flex-col sm:flex-row items-center justify-between gap-3">
                <p className="hidden sm:block text-[12px] text-[#8a9bb0]">
                  Showing{" "}
                  {(currentPage - 1) * ITEMS_PER_PAGE + 1}–
                  {Math.min(currentPage * ITEMS_PER_PAGE, filteredData.length)}{" "}
                  of {filteredData.length} results
                </p>

                {/* Compact prev/next + page label — mobile only */}
                <div className="flex sm:hidden items-center justify-between w-full gap-2">
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                    disabled={currentPage === 1}
                    className="flex items-center gap-1 px-3 py-2 rounded-lg border border-[#dde4ed] text-[#4a6080] text-[12px] font-medium disabled:opacity-40 disabled:cursor-not-allowed active:enabled:border-[#00A95B] active:enabled:text-[#00A95B] transition-colors"
                  >
                    <MdChevronLeft size={16} />
                    Prev
                  </button>
                  <span className="text-[12px] font-semibold text-[#0a2540]">
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    onClick={() =>
                      setCurrentPage((p) => Math.min(totalPages, p + 1))
                    }
                    disabled={currentPage === totalPages}
                    className="flex items-center gap-1 px-3 py-2 rounded-lg border border-[#dde4ed] text-[#4a6080] text-[12px] font-medium disabled:opacity-40 disabled:cursor-not-allowed active:enabled:border-[#00A95B] active:enabled:text-[#00A95B] transition-colors"
                  >
                    Next
                    <MdChevronRight size={16} />
                  </button>
                </div>

                {/* Full numbered pagination — sm and up */}
                <div className="hidden sm:flex items-center gap-1.5">
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                    disabled={currentPage === 1}
                    className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#dde4ed] text-[#4a6080] text-sm disabled:opacity-40 disabled:cursor-not-allowed hover:enabled:border-[#00A95B] hover:enabled:text-[#00A95B] transition-colors"
                  >
                    ‹
                  </button>

                  {pageNumbers()[0] > 1 && (
                    <>
                      <button
                        onClick={() => setCurrentPage(1)}
                        className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#dde4ed] text-[13px] text-[#4a6080] hover:border-[#00A95B] hover:text-[#00A95B] transition-colors"
                      >
                        1
                      </button>
                      {pageNumbers()[0] > 2 && (
                        <span className="text-[#b0bcc9] text-sm px-1">…</span>
                      )}
                    </>
                  )}

                  {pageNumbers().map((page) => (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={`w-8 h-8 flex items-center justify-center rounded-lg border text-[13px] font-medium transition-colors ${
                        page === currentPage
                          ? "border-[#00A95B] bg-[#00A95B] text-white"
                          : "border-[#dde4ed] text-[#4a6080] hover:border-[#00A95B] hover:text-[#00A95B]"
                      }`}
                    >
                      {page}
                    </button>
                  ))}

                  {pageNumbers()[pageNumbers().length - 1] < totalPages && (
                    <>
                      {pageNumbers()[pageNumbers().length - 1] < totalPages - 1 && (
                        <span className="text-[#b0bcc9] text-sm px-1">…</span>
                      )}
                      <button
                        onClick={() => setCurrentPage(totalPages)}
                        className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#dde4ed] text-[13px] text-[#4a6080] hover:border-[#00A95B] hover:text-[#00A95B] transition-colors"
                      >
                        {totalPages}
                      </button>
                    </>
                  )}

                  <button
                    onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                    disabled={currentPage === totalPages}
                    className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#dde4ed] text-[#4a6080] text-sm disabled:opacity-40 disabled:cursor-not-allowed hover:enabled:border-[#00A95B] hover:enabled:text-[#00A95B] transition-colors"
                  >
                    ›
                  </button>
                </div>
              </div>
            )}
          </div>

        </div>
      </div>

      <InvoicePurchaseModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        purchase={selectedPurchase}
      />
    </>
  );
};

/* ── Summary Card ── */
const SummaryCard = ({ label, value, color, bg, border }) => (
  <div
    className={`rounded-xl p-4 flex flex-col gap-1 border ${border}`}
    style={{ background: bg }}
  >
    <span className="text-[11px] font-semibold uppercase tracking-[0.7px] text-[#8a9bb0]">
      {label}
    </span>
    <span
      className="text-[20px] font-bold"
      style={{ color, fontFamily: "'DM Serif Display', serif" }}
    >
      {value}
    </span>
  </div>
);

export default Purchases;